import React, { useState } from "react";
import OrganizationModal from "./index";
import styles from "./style.module.scss";

interface APIStructure {
  organizationId: number;
  organizationName: string;
  type: string;
  organizationEmail: string;
  logo: string;
  organizationLogo: string;
  auditeeMembers: { name: string; email: string }[];
  applications: { applicationId: number; applicationName: string }[];
  auditeeLead: any[];
}

interface OrganizationListProps {
  title: string;
  auditCode: string;
  organizations: APIStructure[];
}

const OrganizationList: React.FC<OrganizationListProps> = ({
  title,
  auditCode,
  organizations = [],
}) => {
  const [selectedOrg, setSelectedOrg] = useState<APIStructure | null>(null);
  const [showModal, setShowModal] = useState(false);

  const handleOpen = (org: APIStructure) => {
    setSelectedOrg(org);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  return (
    <span className={styles.orgListContainer}>
      {/* Comma-separated clickable org names */}
      <span className={styles.orgLinks}>
        {organizations.map((org, index) => (
          <React.Fragment key={org.organizationId}>
            <span
              role="button"
              tabIndex={0}
              className={styles.orgLink}
              onClick={() => handleOpen(org)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleOpen(org);
                }
              }}
            >
              {org.organizationName}
            </span>
            {index < organizations.length - 1 && ", "}
          </React.Fragment>
        ))}
      </span>

      {selectedOrg && (
        <OrganizationModal
          show={showModal}
          onClose={handleClose}
          title="Organization Under Audit ID:"
          auditCode={auditCode}
          organizations={[selectedOrg]} // show only clicked org
        />
      )}
    </span>
  );
};

export default OrganizationList;
